var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 462,
    height: 363,
    viewBox: "0 0 462 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M376.822 32.334C429.618 -18.3262 487.606 1.66705 510 17.9962V363H45.9593C32.9784 355.234 5.70874 328.828 0.476776 285.337C-4.75519 241.845 34.3657 211.856 54.5802 202.297C71.7228 200.206 107.673 187.422 114.332 153.011C120.991 118.6 134.546 103.227 140.492 99.8414C150.599 82.6161 185.142 52.4669 242.456 69.6722C314.098 91.1789 310.828 95.6594 376.822 32.334Z",
    fill: "#EEF6FC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg5);
export default __webpack_public_path__ + "static/media/bg5.186fe2a595890107fc8cc6bd79f2e128.svg";
export { ForwardRef as ReactComponent };